import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage, FormattedNumber} from 'react-intl'
import {
    Box,
    Flex,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import VatLabel from '../../vat-label'

const OrderTotal = ({variant, basket, isEstimate = false, isVATFlag}) => {
    const style = useMultiStyleConfig('OrderSummary', {variant})
    return (
        <Box>
            <Box
                {...style?.checkoutSection?.checkoutContainer}
                {...style?.checkoutSection?.checkoutTotalContainer}
            >
                {isEstimate ? (
                    <Flex>
                        <Text {...style?.checkoutSection?.totalText}>
                            <FormattedMessage
                                defaultMessage="TOTAL"
                                id="order_summary.label.estimated_total"
                            />
                        </Text>
                        <Text {...style?.checkoutSection?.vatInCheckoutButton}>
                            {isVATFlag && (
                                <VatLabel
                                    textStyle="body-xxsmall"
                                    amount={basket?.taxTotal}
                                    hideVatRate
                                />
                            )}
                        </Text>
                    </Flex>
                ) : (
                    <Text {...style?.checkoutSection?.totalText}>
                        <FormattedMessage
                            defaultMessage="Order Total"
                            id="order_summary.label.order_total"
                        />
                    </Text>
                )}
                <Text {...style?.checkoutSection?.totalText}>
                    <FormattedNumber
                        style="currency"
                        currency={basket?.currency}
                        value={basket?.orderTotal || basket?.productTotal}
                    />
                </Text>
            </Box>
        </Box>
    )
}

OrderTotal.propTypes = {
    basket: PropTypes.object,
    variant: PropTypes.string,
    isEstimate: PropTypes.bool,
    fontSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
    isVATFlag: PropTypes.bool,
}

export default OrderTotal
